<template>

    <div>
        <div class="modal fade" id="pendingImageModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close()"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                        <h4 class="modal-title">Afbeelding verwerken</h4>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="projects" class="control-label">Project*</label>
                            <v-select
                                id="projects"
                                v-model="form.project"
                                :options="getProjects"
                                label="name"
                                :disabled="posting"
                                :reduce="option => option.uuid"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label for="tasks" class="control-label">Taak</label>
                            <v-select
                                id="tasks"
                                v-model="form.task"
                                :options="getTasks"
                                label="name"
                                :disabled="posting || form.project === null"
                                :reduce="option => option.uuid"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label for="categories" class="control-label">Categorie</label>
                            <v-select
                                id="categories"
                                v-model="form.category"
                                :options="imagespecs.categories"
                                label="name"
                                :disabled="posting"
                                :reduce="option => option.id"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label for="material" class="control-label">Materiaal</label>
                            <v-select
                                id="material"
                                v-model="form.material"
                                :options="imagespecs.materials"
                                label="name"
                                :disabled="posting"
                                :reduce="option => option.id"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label for="status" class="control-label">Status</label>
                            <v-select
                                id="status"
                                v-model="form.status"
                                :options="imagespecs.statuses"
                                label="name"
                                :disabled="posting"
                                :reduce="option => option.id"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label for="types" class="control-label">Type</label>
                            <v-select
                                id="types"
                                v-model="form.type"
                                :options="imagespecs.types"
                                label="name"
                                :disabled="posting"
                                :reduce="option => option.id"
                            ></v-select>
                        </div>
                        <div class="form-group">
                            <label for="crm" class="control-label">Fotograaf</label>
                            <div class="input-group">
                                <input type="text" class="form-control" id="crm"
                                    :value="crmname"
                                    :disabled="true"
                                />
                                <span class="input-group-btn">
                                    <button type="button" @click="openCrmSelector()" class="btn btn-info btn-flat">Zoek</button>
                                </span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label">Foto is genomen op</label>
                            <date-picker v-model="form.taken_at" format="DD-MM-YYYY" type="date" lang="en"></date-picker>
                        </div>
                        <div class="form-group">
                            <label class="control-label">Beschikbaar stellen voor afmetingen*</label>
                            <div>
                                <div class="check" v-if="image.processablesizes" v-for="size in imagespecs.sizes">
                                    <label>
                                        <input type="checkbox"
                                            :disabled="image.processablesizes.indexOf(size.slug) === -1"
                                            v-model="form.sizes"
                                            :value="size.slug"
                                        />
                                        {{ size.name }} ({{ size.width }}px x {{ size.height }}px)
                                    </label>
                                </div>
                            </div>
                            <span class="help-block">Wanneer afmetingen uitgeschakeld zijn, komt dit omdat het origineel te klein is om voor deze afmetingen gebruikt te kunnen worden.</span>
                        </div>
                        <div class="form-group text-right">
                            <button
                                class="btn btn-primary btn-sm"
                                :disabled="!canSubmit"
                                @click="onSubmit"
                            >Opslaan</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <crm-selector
            ref="ipCrmSelector"
            :on-selected="crmSelect"
        ></crm-selector>
    </div>

</template>

<script>

    import vSelect from 'vue-select';
    import CrmSelector from "../Common/Selectors/CrmSelector";
    import DatePicker from 'vue2-datepicker';
    import moment from 'moment';

    export default {

        components: {
            vSelect,
            CrmSelector,
            DatePicker,
        },

        computed: {

            canSubmit() {
                return this.posting === false &&
                    this.form.sizes.length > 0 &&
                    this.form.project !== null;
            },

            getProjects() {
                return Object.values(this.projects);
            },

            getTasks() {
                if (this.form.project === null || this.projects.length === 0) {
                    return [];
                }
                return this.projects.filter(project => project.uuid === this.form.project)[0].tasks;
            },

            postData() {
                let data = JSON.parse(JSON.stringify(this.form));
                data.taken_at = moment(this.form.taken_at).format('YYYY-MM-DD');
                return data;
            }

        },

        data() {
            return {
                crmname:'',
                form:{
                    category:null,
                    crm:null,
                    material:null,
                    project:null,
                    status:null,
                    taken_at:null,
                    task:null,
                    type:null,
                    sizes:[],
                },
                image:{},
                posting:false,
            }
        },

        methods: {

            close() {
                this.crmname = '';
                this.form = {
                    category:null,
                        crm:null,
                        material:null,
                        project:null,
                        status:null,
                        taken_at:null,
                        task:null,
                        type:null,
                        sizes:[],
                };
                this.image = {};
                $('#pendingImageModal').modal('show');
            },

            crmSelect(contact){
                this.form.crm = contact.uuid;
                this.crmname = this.getCrmName(contact);
                this.$refs.ipCrmSelector.closeSelector();
            },

            getCrmName(contact){
                if (contact.isContact === false) {
                    return contact.company_name;
                }
                if (contact.company_name === null || contact.company_name === "") {
                    return contact.full_name;
                }
                return contact.full_name + " (" + contact.company_name + ")";
            },

            hide() {
                $('#pendingImageModal').modal('hide');
                this.crmname = '';
                this.form = {
                    category:null,
                    crm:null,
                    material:null,
                    project:null,
                    status:null,
                    taken_at:null,
                    task:null,
                    type:null,
                    sizes:[],
                };
                this.image = {};
            },

            onSubmit() {
                if (!this.canSubmit) {
                    return;
                }
                this.posting = true;
                axios.post(this.route('api.v1.images.storepending', {image_uuid:this.image.uuid}), this.postData)
                    .then(() => {
                        this.$snotify.success('De afbeelding wordt op de achtergrond verwerkt');
                        this.hide();
                        this.$emit('pending-image-is-being-processed',this.image.uuid);
                    })
                    .catch(() => this.$snotify.error('Er is een fout opgetreden bij het verwerken van de afbeelding'))
                    .finally(() => this.posting = false);
            },

            openCrmSelector() {
                this.$refs.ipCrmSelector.openSelector();
            },

            show(image) {
                this.image = image;
                $('#pendingImageModal').modal('show');
            },

        },

        props: {
            imagespecs: {
                type:Object,
                default:{
                    categories:[],
                    materials:[],
                    sizes:[],
                    statuses:[],
                    types:[],
                },
            },
            projects: {
                type:Array,
                default:[],
            },
        }

    }

</script>
